import { motion } from "framer-motion";
import { fadeInUp } from "@/lib/animations";
import photoBreak5 from "@/assets/photo-break-5.jpg";

const HeroFoldBreak = () => {
  return (
    <motion.div
      className="relative w-full h-[35vh] md:h-[45vh] overflow-hidden"
      variants={fadeInUp}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >
      <img
        src={photoBreak5}
        alt="Camilla Felix - Automaquiagem"
        className="w-full h-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background via-background/30 to-background pointer-events-none" />

      {/* CRO Overlay */}
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 z-10">
        <div className="px-6 py-4 md:px-10 md:py-6 rounded-2xl bg-background/60 backdrop-blur-sm border border-border-gold/30 shadow-elegant">
          <div className="flex items-center justify-center gap-2.5 mb-2">
            <span className="w-2.5 h-2.5 rounded-full bg-primary shadow-[0_0_8px_hsl(var(--primary)/0.6)] animate-pulse" />
            <span className="text-xs md:text-sm font-semibold text-primary tracking-wide uppercase">
              MAIS DE 94 MIL MULHERES ACOMPANHAM A JORNADA DA CAMILA
            </span>
          </div>
          <p className="text-sm md:text-lg text-foreground-light/90 italic">
            Método simples. Resultado real. Sem filtro.
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default HeroFoldBreak;
